import {observer} from 'mobx-react-lite';
import React, {useCallback, useRef, useState} from 'react';

import {Positioning} from '_/utilities/types';

import {Content, StyledButton} from './styles';

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * Icon component for the button
   */
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  bordered?: boolean;
  danger?: boolean;
  flat?: boolean;
  testId?: string;
  iconPlacement?: IconPlacement;
  /** Flag that rotates the icon b ythe amount in degrees, useful for chevrons and similar icons */
  iconRotation?: number;
  selectBoxPlacement?: Positioning;

  ref?: React.Ref<HTMLButtonElement>;
}

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export type IconButtonProps = Omit<Props, 'children'>;

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export enum IconPlacement {
  Left,
  Right,
  Middle,
}

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export function ButtonComponent({
  Icon,
  bordered,
  children,
  danger,
  flat,
  testId,
  iconPlacement = IconPlacement.Right,
  iconRotation = 0,
  onClick,
  ref,
  ...props
}: Props): React.ReactElement {
  const [expanded, setExpanded] = useState(false);

  const internalRef = useRef<HTMLButtonElement>(null);

  const handleClick = useCallback(
    (event: any) => {
      if (!onClick && !expanded) {
        setExpanded(true);
      }

      onClick?.(event);
    },
    [expanded, onClick]
  );

  const refCallback = useCallback(
    (element: HTMLButtonElement) => {
      internalRef.current = element;

      /* istanbul ignore if */
      if (ref) {
        if (typeof ref === 'function') {
          /* istanbul ignore next */
          ref(internalRef.current);
        } else {
          ref.current = internalRef.current;
        }
      }
    },
    [ref]
  );

  return (
    <StyledButton
      ref={refCallback}
      bordered={bordered}
      danger={danger}
      data-testid={testId}
      flat={flat}
      Icon={Icon}
      iconPlacement={iconPlacement}
      iconRotation={iconRotation}
      onClick={handleClick}
      {...props}
    >
      <Content iconPlacement={iconPlacement} iconRotation={iconRotation}>
        {Icon ? <Icon /> : null}
        {children}
      </Content>
    </StyledButton>
  );
}

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export default observer(ButtonComponent);
